// import React, { useEffect, useState } from "react";
// import {
//   Modal,
//   Button,
//   Form,
//   Table,
//   Pagination,
//   Spinner,
// } from "react-bootstrap";
// import axios from "axios";
// import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";

// const API_URL = process.env.REACT_APP_API_URL;
// const imageAPIURL = process.env.REACT_APP_Image_URL;

// function AccountList() {
//   const [visits, setVisits] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [searchName, setSearchName] = useState("");
//   const [searchAccount, setSearchAccount] = useState("");
//   const [submittedSearchName, setSubmittedSearchName] = useState("");
//   const [submittedSearchAccount, setSubmittedSearchAccount] = useState("");
//   const [showConfirmModal, setShowConfirmModal] = useState(false);
//   const [selectedAccount, setSelectedAccount] = useState(null);
//   const [selectedAction, setSelectedAction] = useState(null);

//   const getAuthToken = () => localStorage.getItem("token");

//   const [isFilterActive, setIsFilterActive] = useState(false);
//   const handleToggle = () => setIsFilterActive(!isFilterActive);

//   const fetchVisits = async (page = 1, name = "", account = "") => {
//     setLoading(true);
//     const token = getAuthToken();
//     try {
//       const response = await axios.get(
//         `${API_URL}/bank-account-pending-list?page=${page}&limit=10&name=${name}&account_number=${account}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         },
//       );
//       const result = response.data;
//       if (result.success === "1") {
//         setVisits(result.data);
//         setTotalPages(result.totalPages || 1);
//         setCurrentPage(result.currentPage || page);
//       }
//     } catch (err) {
//       setError("Failed to fetch visit list.");
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleStatusAction = (accountId, action) => {
//     setSelectedAccount(accountId);
//     setSelectedAction(action);
//     setShowConfirmModal(true);
//   };

//   const confirmStatusChange = async () => {
//     const token = getAuthToken();
//     try {
//       await axios.put(
//         `${API_URL}/bank-account-update-status`,
//         { id: selectedAccount, status: selectedAction },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         },
//       );
//       fetchVisits(currentPage, submittedSearchName, submittedSearchAccount);
//     } catch (err) {
//       setError("Failed to update account status.");
//       console.error(err);
//     } finally {
//       setShowConfirmModal(false);
//     }
//   };

//   useEffect(() => {
//     fetchVisits(currentPage, submittedSearchName, submittedSearchAccount);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [currentPage, submittedSearchName, submittedSearchAccount]);

//   const handlePageChange = (pageNumber) => {
//     if (pageNumber >= 1 && pageNumber <= totalPages) {
//       setCurrentPage(pageNumber);
//     }
//   };

//   const handleSearchSubmit = (e) => {
//     e.preventDefault();
//     setSubmittedSearchName(searchName);
//     setSubmittedSearchAccount(searchAccount);
//     setCurrentPage(1);
//   };

//   // ---------------- LOADING ----------------
//   if (loading) {
//     return (
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         <Spinner animation="border" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </Spinner>
//       </div>
//     );
//   }

//   // ---------------- ERROR ----------------
//   if (error) {
//     return (
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//         }}
//       >
//         <div className="alert alert-danger">{error}</div>
//       </div>
//     );
//   }

//   // ---------------- MAIN ----------------
//   return (
//     <>
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//           fontFamily: "'Poppins', 'DM Sans', sans-serif",
//         }}
//       >
//         <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//           {/* 🎯 HEADER CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               padding: "20px 24px",
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               marginBottom: "20px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div
//               style={{
//                 width: "52px",
//                 height: "52px",
//                 borderRadius: "14px",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#ffffff",
//                 fontSize: "24px",
//                 boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                 flexShrink: 0,
//               }}
//             >
//               🏦
//             </div>
//             <div style={{ flex: 1, minWidth: "200px" }}>
//               <h1
//                 style={{
//                   margin: 0,
//                   fontSize: "24px",
//                   fontWeight: "800",
//                   color: "#1e3a5f",
//                   letterSpacing: "-0.5px",
//                 }}
//               >
//                 Pending Account List
//               </h1>
//               <p
//                 style={{
//                   margin: "2px 0 0",
//                   fontSize: "13px",
//                   color: "#64748b",
//                   fontWeight: "500",
//                 }}
//               >
//                 Approve or reject pending bank account requests
//               </p>
//             </div>

//             <button
//               className={`filter-toggle-btn btn ${
//                 isFilterActive ? "active" : ""
//               }`}
//               onClick={handleToggle}
//               style={{
//                 width: "44px",
//                 height: "44px",
//                 borderRadius: "12px",
//                 border: "1.5px solid #e2e8f0",
//                 background: isFilterActive ? "#1e5799" : "#ffffff",
//                 color: isFilterActive ? "#ffffff" : "#1e3a5f",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 fontSize: "20px",
//                 cursor: "pointer",
//                 transition: "all 0.25s ease",
//                 boxShadow: isFilterActive
//                   ? "0 8px 20px rgba(30, 87, 153, 0.3)"
//                   : "none",
//               }}
//               title={isFilterActive ? "Hide Filters" : "Show Filters"}
//             >
//               {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
//             </button>
//           </div>

//           {/* 🎯 MAIN CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 height: "5px",
//                 background:
//                   "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//               }}
//             />

//             <div style={{ padding: "30px" }}>
//               {/* FILTER PANEL */}
//               {isFilterActive && (
//                 <div
//                   style={{
//                     background: "#f8fafc",
//                     border: "1.5px dashed #cbd5e1",
//                     borderRadius: "12px",
//                     padding: "20px",
//                     marginBottom: "24px",
//                   }}
//                 >
//                   <Form
//                     className="d-flex gap-2 flex-wrap-mobile"
//                     onSubmit={handleSearchSubmit}
//                   >
//                     <Form.Group className="w-100" controlId="searchName">
//                       <Form.Control
//                         type="text"
//                         placeholder="Search by Name"
//                         value={searchName}
//                         onChange={(e) => setSearchName(e.target.value)}
//                       />
//                     </Form.Group>

//                     <Form.Group className="w-100" controlId="searchAccount">
//                       <Form.Control
//                         type="text"
//                         placeholder="Search by Account"
//                         value={searchAccount}
//                         onChange={(e) => setSearchAccount(e.target.value)}
//                       />
//                     </Form.Group>

//                     <Button variant="primary" type="submit">
//                       Search
//                     </Button>
//                   </Form>
//                 </div>
//               )}

//               {/* TABLE */}
//               <div className="table-responsive">
//                 <Table striped bordered hover>
//                   <thead>
//                     <tr>
//                       <th>#</th>
//                       <th>Name</th>
//                       <th>Mobile</th>
//                       <th>A/C Name</th>
//                       <th>Bank</th>
//                       <th>Branch Name</th>
//                       <th>A/C Number</th>
//                       <th>IFSC Code</th>
//                       <th>Image</th>
//                       <th>Date</th>
//                       <th>Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {visits.length > 0 ? (
//                       visits.map((visit, index) => (
//                         <tr key={visit.id}>
//                           <td>{(currentPage - 1) * 10 + index + 1}</td>
//                           <td>
//                             {visit.username
//                               ? visit.username.charAt(0).toUpperCase() +
//                                 visit.username.slice(1).toLowerCase()
//                               : ""}
//                           </td>
//                           <td>{visit.mobile}</td>
//                           <td>
//                             {visit.account_holder_name
//                               ? visit.account_holder_name
//                                   .charAt(0)
//                                   .toUpperCase() +
//                                 visit.account_holder_name
//                                   .slice(1)
//                                   .toLowerCase()
//                               : ""}
//                           </td>
//                           <td>
//                             {visit.bank_name
//                               ? visit.bank_name.charAt(0).toUpperCase() +
//                                 visit.bank_name.slice(1).toLowerCase()
//                               : ""}
//                           </td>
//                           <td>{visit.bank_branch_name || "NA"}</td>
//                           <td>{visit.account_number}</td>
//                           <td>{visit.ifsc_code}</td>
//                           <td>
//                             {visit.image ? (
//                               <div
//                                 style={{
//                                   display: "flex",
//                                   gap: "8px",
//                                   flexWrap: "nowrap",
//                                   alignItems: "center",
//                                 }}
//                               >
//                                 {visit.image
//                                   .split(",")
//                                   .map((img, index) => {
//                                     const fileUrl = `${imageAPIURL}/loanlead/${img.trim()}`;
//                                     return (
//                                       <div
//                                         key={index}
//                                         style={{
//                                           position: "relative",
//                                           display: "inline-block",
//                                           width: "60px",
//                                           height: "60px",
//                                           overflow: "hidden",
//                                           borderRadius: "6px",
//                                           border: "1px solid #ddd",
//                                           flex: "0 0 auto",
//                                         }}
//                                       >
//                                         {img
//                                           .toLowerCase()
//                                           .endsWith(".pdf") ? (
//                                           <div
//                                             style={{
//                                               width: "100%",
//                                               height: "100%",
//                                               display: "flex",
//                                               alignItems: "center",
//                                               justifyContent: "center",
//                                               background: "#f5f5f5",
//                                             }}
//                                           >
//                                             <span
//                                               style={{
//                                                 fontSize: "10px",
//                                                 fontWeight: "bold",
//                                               }}
//                                             >
//                                               PDF
//                                             </span>
//                                           </div>
//                                         ) : (
//                                           <img
//                                             src={fileUrl}
//                                             alt={`Uploaded ${index + 1}`}
//                                             style={{
//                                               width: "100%",
//                                               height: "100%",
//                                               objectFit: "cover",
//                                               cursor: "pointer",
//                                             }}
//                                             onClick={() =>
//                                               window.open(fileUrl, "_blank")
//                                             }
//                                           />
//                                         )}
//                                       </div>
//                                     );
//                                   })}
//                               </div>
//                             ) : (
//                               "No Document"
//                             )}
//                           </td>
//                           <td>
//                             {new Date(visit.created_at)
//                               .toLocaleDateString("en-GB")
//                               .replace(/\//g, "-")}
//                           </td>
//                           <td>
//                             {visit.status === "pending" && (
//                               <div className="d-flex gap-2">
//                                 <Button
//                                   variant="success"
//                                   size="sm"
//                                   onClick={() =>
//                                     handleStatusAction(visit.id, "success")
//                                   }
//                                 >
//                                   Approve
//                                 </Button>
//                                 <Button
//                                   variant="danger"
//                                   size="sm"
//                                   onClick={() =>
//                                     handleStatusAction(visit.id, "reject")
//                                   }
//                                 >
//                                   Reject
//                                 </Button>
//                               </div>
//                             )}
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="11" className="text-center">
//                           No Account found.
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </Table>
//               </div>

//               {/* PAGINATION */}
//               <div className="d-flex justify-content-end mt-3">
//                 <Pagination>
//                   <Pagination.Prev
//                     onClick={() => handlePageChange(currentPage - 1)}
//                     disabled={currentPage === 1}
//                   />
//                   {[...Array(totalPages)].map((_, index) => (
//                     <Pagination.Item
//                       key={index + 1}
//                       active={index + 1 === currentPage}
//                       onClick={() => handlePageChange(index + 1)}
//                     >
//                       {index + 1}
//                     </Pagination.Item>
//                   ))}
//                   <Pagination.Next
//                     onClick={() => handlePageChange(currentPage + 1)}
//                     disabled={currentPage === totalPages}
//                   />
//                 </Pagination>
//               </div>
//             </div>
//           </div>

//           {/* Footer Copyright */}
//           <p
//             style={{
//               textAlign: "center",
//               color: "#94a3b8",
//               fontSize: "12.5px",
//               marginTop: "24px",
//               fontWeight: "500",
//             }}
//           >
//             © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
//             Rights Reserved.
//           </p>
//         </div>
//       </div>

//       {/* 🎯 CONFIRM MODAL */}
//       <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Action</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           Are you sure you want to{" "}
//           {selectedAction === "success" ? "approve" : "reject"} this account?
//         </Modal.Body>
//         <Modal.Footer>
//           <Button
//             variant="secondary"
//             onClick={() => setShowConfirmModal(false)}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant={selectedAction === "success" ? "success" : "danger"}
//             onClick={confirmStatusChange}
//           >
//             Confirm
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// }

// export default AccountList;
import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import axios from "axios";
import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import Swal from "sweetalert2";

const API_URL = process.env.REACT_APP_API_URL;
const imageAPIURL = process.env.REACT_APP_Image_URL;
const LIMIT = 10;

function AccountList() {
  const [visits, setVisits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [searchName, setSearchName] = useState("");
  const [searchAccount, setSearchAccount] = useState("");
  const [submittedSearchName, setSubmittedSearchName] = useState("");
  const [submittedSearchAccount, setSubmittedSearchAccount] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [selectedAction, setSelectedAction] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const [isFilterActive, setIsFilterActive] = useState(false);

  const getAuthToken = () => localStorage.getItem("token");

  const handleToggle = () => setIsFilterActive(!isFilterActive);

  // ═══════════════════════════════════════════
  // 🔹 FETCH PENDING ACCOUNTS
  // ═══════════════════════════════════════════
  const fetchVisits = async (page = 1, name = "", account = "") => {
    setLoading(true);
    setError(null);
    const token = getAuthToken();
    try {
      const response = await axios.get(
        `${API_URL}/bank-account-pending-list?page=${page}&limit=${LIMIT}&name=${name}&account_number=${account}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const result = response.data;
      if (result.success === "1") {
        setVisits(result.data || []);

        const pages = Number(result.totalPages) || 1;
        const total = Number(result.total) || (result.data?.length || 0);

        setTotalPages(pages);
        setTotalItems(total);
        setCurrentPage(Number(result.currentPage) || Number(page));
      } else {
        setError(result.message || "Failed to fetch pending list.");
        setVisits([]);
        setTotalPages(1);
        setTotalItems(0);
      }
    } catch (err) {
      setError("Failed to fetch pending list.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVisits(currentPage, submittedSearchName, submittedSearchAccount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, submittedSearchName, submittedSearchAccount]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  const handleSearchSubmit = (e) => {
    if (e) e.preventDefault();
    setSubmittedSearchName(searchName);
    setSubmittedSearchAccount(searchAccount);
    setCurrentPage(1);
  };

  const handleClearFilters = () => {
    setSearchName("");
    setSearchAccount("");
    setSubmittedSearchName("");
    setSubmittedSearchAccount("");
    setCurrentPage(1);
  };

  // ═══════════════════════════════════════════
  // 🔹 APPROVE / REJECT
  // ═══════════════════════════════════════════
  const handleStatusAction = (accountId, action) => {
    setSelectedAccount(accountId);
    setSelectedAction(action);
    setShowConfirmModal(true);
  };

  const confirmStatusChange = async () => {
    setActionLoading(true);
    const token = getAuthToken();
    try {
      const response = await axios.put(
        `${API_URL}/bank-account-update-status`,
        { id: selectedAccount, status: selectedAction },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success === "1" || response.status === 200) {
        Swal.fire({
          icon: "success",
          title: selectedAction === "success" ? "Approved!" : "Rejected!",
          text: `Account has been ${selectedAction === "success" ? "approved" : "rejected"} successfully.`,
          timer: 1600,
          showConfirmButton: false,
        });
        fetchVisits(currentPage, submittedSearchName, submittedSearchAccount);
      } else {
        throw new Error(response.data.message || "Failed to update status.");
      }
    } catch (err) {
      console.error("Status update error:", err);
      Swal.fire(
        "Error",
        err.response?.data?.message || "Failed to update account status.",
        "error"
      );
    } finally {
      setActionLoading(false);
      setShowConfirmModal(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 PAGINATION PAGES
  // ═══════════════════════════════════════════
  const getPageNumbers = () => {
    const pages = [];
    const showEllipsis = totalPages > 7;

    pages.push(1);
    if (showEllipsis && currentPage > 4) pages.push("left-ellipsis");

    const start = Math.max(2, currentPage - 2);
    const end = Math.min(totalPages - 1, currentPage + 2);

    for (let i = start; i <= end; i++) pages.push(i);

    if (showEllipsis && currentPage < totalPages - 3) pages.push("right-ellipsis");
    if (totalPages > 1) pages.push(totalPages);

    return pages;
  };

  // ═══════════════════════════════════════════
  // 🔹 LOADING
  // ═══════════════════════════════════════════
  if (loading) {
    return (
      <div
        style={{
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        }}
      >
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "4px solid #e2e8f0",
            borderTop: "4px solid #1e5799",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <style>{`@keyframes spin { from {transform:rotate(0deg);} to {transform:rotate(360deg);} }`}</style>
      </div>
    );
  }

  // ═══════════════════════════════════════════
  // 🔹 ERROR
  // ═══════════════════════════════════════════
  if (error) {
    return (
      <div
        style={{
          minHeight: "80vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "30px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            background: "#feeaeb",
            border: "1.5px solid #fecaca",
            color: "#991b1b",
            borderRadius: "12px",
            padding: "20px 24px",
            fontWeight: "600",
            fontSize: "14px",
            display: "flex",
            gap: "16px",
            alignItems: "center",
          }}
        >
          <span>⚠️ {error}</span>
          <button
            onClick={() => fetchVisits(1)}
            style={{
              padding: "8px 18px",
              borderRadius: "8px",
              border: "none",
              background: "#dc2626",
              color: "#ffffff",
              fontWeight: "700",
              fontSize: "12px",
              cursor: "pointer",
            }}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  // ═══════════════════════════════════════════
  // 🎨 UI RENDER
  // ═══════════════════════════════════════════
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        padding: "24px",
        fontFamily: "'Poppins', 'DM Sans', sans-serif",
      }}
    >
      <div style={{ maxWidth: "1500px", margin: "0 auto" }}>
        <div
          style={{
            background: "#ffffff",
            borderRadius: "20px",
            boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
            border: "1.5px solid #e2e8f0",
            overflow: "hidden",
          }}
        >
          {/* Top Gradient */}
          <div
            style={{
              height: "5px",
              background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
            }}
          />

          {/* Header */}
          <div
            style={{
              padding: "24px 30px",
              background: "linear-gradient(135deg, #ffffff, #f8fafc)",
              borderBottom: "1.5px solid #e2e8f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "14px",
                  background: "linear-gradient(135deg, #d97706, #b45309)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  fontSize: "22px",
                  boxShadow: "0 8px 20px rgba(217, 119, 6, 0.3)",
                  flexShrink: 0,
                }}
              >
                ⏳
              </div>
              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "22px",
                    fontWeight: "800",
                    color: "#1e3a5f",
                  }}
                >
                  Pending Account List
                </h2>
                <p
                  style={{
                    margin: "2px 0 0",
                    fontSize: "12.5px",
                    color: "#64748b",
                    fontWeight: "500",
                  }}
                >
                  Approve or reject pending bank account requests ({totalItems}{" "}
                  total)
                </p>
              </div>
            </div>

            <button
              onClick={handleToggle}
              style={{
                width: "42px",
                height: "42px",
                borderRadius: "10px",
                border: isFilterActive ? "none" : "1.5px solid #e2e8f0",
                background: isFilterActive
                  ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                  : "#ffffff",
                color: isFilterActive ? "#ffffff" : "#1e5799",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "18px",
                cursor: "pointer",
                boxShadow: isFilterActive
                  ? "0 6px 18px rgba(30, 87, 153, 0.3)"
                  : "none",
              }}
              title="Toggle Filters"
            >
              {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
            </button>
          </div>

          {/* Body */}
          <div style={{ padding: "24px 30px" }}>
            {/* Filter Panel */}
            {isFilterActive && (
              <div
                style={{
                  background: "#f8fafc",
                  borderRadius: "14px",
                  padding: "18px",
                  marginBottom: "24px",
                  border: "1.5px solid #e2e8f0",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    flexWrap: "wrap",
                    alignItems: "flex-end",
                  }}
                >
                  <div style={{ flex: 1, minWidth: "180px" }}>
                    <label style={labelStyle}>Name</label>
                    <input
                      type="text"
                      placeholder="Search by Name"
                      value={searchName}
                      onChange={(e) => setSearchName(e.target.value)}
                      style={inputStyle}
                    />
                  </div>

                  <div style={{ flex: 1, minWidth: "180px" }}>
                    <label style={labelStyle}>Account Number</label>
                    <input
                      type="text"
                      placeholder="Search by Account"
                      value={searchAccount}
                      onChange={(e) => setSearchAccount(e.target.value)}
                      style={inputStyle}
                    />
                  </div>

                  <div style={{ display: "flex", gap: "8px" }}>
                    <button
                      onClick={handleSearchSubmit}
                      style={{
                        padding: "10px 22px",
                        borderRadius: "10px",
                        border: "none",
                        background:
                          "linear-gradient(135deg, #1e5799, #2b6cb0)",
                        color: "#ffffff",
                        fontWeight: "700",
                        cursor: "pointer",
                        height: "42px",
                      }}
                    >
                      Search
                    </button>
                    <button
                      onClick={handleClearFilters}
                      style={{
                        padding: "10px 18px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        color: "#64748b",
                        fontWeight: "700",
                        cursor: "pointer",
                        height: "42px",
                      }}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Table */}
            <div
              style={{
                overflowX: "auto",
                overflowY: "visible",
                borderRadius: "14px",
                border: "1.5px solid #e2e8f0",
              }}
            >
              <table
                style={{
                  width: "100%",
                  minWidth: "1300px",
                  borderCollapse: "collapse",
                  fontSize: "13px",
                }}
              >
                <thead>
                  <tr
                    style={{
                      background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                    }}
                  >
                    {[
                      "S.N",
                      "Name",
                      "Mobile",
                      "A/C Name",
                      "Bank",
                      "Branch",
                      "A/C Number",
                      "IFSC",
                      "Document",
                      "Date",
                      "Action",
                    ].map((th, i) => (
                      <th
                        key={i}
                        style={{
                          padding: "14px 12px",
                          color: "#ffffff",
                          fontWeight: "700",
                          fontSize: "11.5px",
                          textAlign: "left",
                          letterSpacing: "0.5px",
                          textTransform: "uppercase",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {th}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {visits.length > 0 ? (
                    visits.map((visit, index) => (
                      <tr
                        key={visit.id}
                        style={{ borderBottom: "1px solid #f1f5f9" }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#f8fafc")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "transparent")
                        }
                      >
                        <td style={cellBlue}>
                          {(currentPage - 1) * LIMIT + index + 1}
                        </td>
                        <td style={cellDark}>
                          {visit.username
                            ? visit.username.charAt(0).toUpperCase() +
                              visit.username.slice(1).toLowerCase()
                            : "-"}
                        </td>
                        <td style={cellGray}>{visit.mobile || "-"}</td>
                        <td style={cellDark}>
                          {visit.account_holder_name
                            ? visit.account_holder_name
                                .charAt(0)
                                .toUpperCase() +
                              visit.account_holder_name.slice(1).toLowerCase()
                            : "-"}
                        </td>
                        <td style={cellDark}>
                          {visit.bank_name
                            ? visit.bank_name.charAt(0).toUpperCase() +
                              visit.bank_name.slice(1).toLowerCase()
                            : "-"}
                        </td>
                        <td style={cellGray}>
                          {visit.bank_branch_name || "NA"}
                        </td>
                        <td style={cellGray}>{visit.account_number || "-"}</td>
                        <td style={cellGray}>{visit.ifsc_code || "-"}</td>
                        <td style={{ padding: "12px" }}>
                          {visit.image ? (
                            <div
                              style={{
                                display: "flex",
                                gap: "8px",
                                flexWrap: "nowrap",
                                alignItems: "center",
                              }}
                            >
                              {visit.image.split(",").map((img, i) => {
                                const fileUrl = `${imageAPIURL}/loanlead/${img.trim()}`;
                                return (
                                  <div
                                    key={i}
                                    style={{
                                      width: "56px",
                                      height: "56px",
                                      overflow: "hidden",
                                      borderRadius: "8px",
                                      border: "1.5px solid #e2e8f0",
                                      flexShrink: 0,
                                    }}
                                  >
                                    {img.toLowerCase().endsWith(".pdf") ? (
                                      <a
                                        href={fileUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          width: "100%",
                                          height: "100%",
                                          background: "#feeaeb",
                                          color: "#dc2626",
                                          fontSize: "10px",
                                          fontWeight: "700",
                                          textDecoration: "none",
                                        }}
                                      >
                                        PDF
                                      </a>
                                    ) : (
                                      <img
                                        src={fileUrl}
                                        alt={`doc-${i}`}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover",
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          window.open(fileUrl, "_blank")
                                        }
                                        onError={(e) => {
                                          e.target.src =
                                            "https://placehold.co/56x56/cccccc/666666?text=No+Image";
                                        }}
                                      />
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            <span
                              style={{
                                color: "#94a3b8",
                                fontSize: "12px",
                                fontWeight: "600",
                              }}
                            >
                              No Document
                            </span>
                          )}
                        </td>
                        <td style={{ ...cellGray, whiteSpace: "nowrap" }}>
                          {visit.created_at
                            ? new Date(visit.created_at)
                                .toLocaleDateString("en-GB")
                                .replace(/\//g, "-")
                            : "-"}
                        </td>
                        <td style={{ padding: "12px" }}>
                          {visit.status === "pending" && (
                            <div
                              style={{
                                display: "flex",
                                gap: "8px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              <button
                                onClick={() =>
                                  handleStatusAction(visit.id, "success")
                                }
                                style={{
                                  padding: "7px 14px",
                                  borderRadius: "8px",
                                  border: "none",
                                  background:
                                    "linear-gradient(135deg, #059669, #047857)",
                                  color: "#ffffff",
                                  fontSize: "12px",
                                  fontWeight: "700",
                                  cursor: "pointer",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  boxShadow:
                                    "0 4px 12px rgba(5, 150, 105, 0.25)",
                                }}
                              >
                                <FaCheckCircle size={12} /> Approve
                              </button>
                              <button
                                onClick={() =>
                                  handleStatusAction(visit.id, "reject")
                                }
                                style={{
                                  padding: "7px 14px",
                                  borderRadius: "8px",
                                  border: "none",
                                  background:
                                    "linear-gradient(135deg, #dc2626, #b91c1c)",
                                  color: "#ffffff",
                                  fontSize: "12px",
                                  fontWeight: "700",
                                  cursor: "pointer",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  boxShadow:
                                    "0 4px 12px rgba(220, 38, 38, 0.25)",
                                }}
                              >
                                <FaTimesCircle size={12} /> Reject
                              </button>
                            </div>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="11"
                        style={{
                          padding: "50px",
                          textAlign: "center",
                          color: "#94a3b8",
                          fontWeight: "600",
                        }}
                      >
                        📭 No pending accounts found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "24px",
                  gap: "6px",
                  flexWrap: "wrap",
                }}
              >
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  ‹ Prev
                </button>

                {getPageNumbers().map((p, i) => {
                  if (p === "left-ellipsis" || p === "right-ellipsis") {
                    return (
                      <span
                        key={`ellipsis-${i}`}
                        style={{
                          padding: "0 6px",
                          color: "#94a3b8",
                          fontWeight: "700",
                        }}
                      >
                        ...
                      </span>
                    );
                  }
                  const isActive = p === currentPage;
                  return (
                    <button
                      key={p}
                      onClick={() => handlePageChange(p)}
                      style={{
                        minWidth: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: isActive ? "none" : "1.5px solid #e2e8f0",
                        background: isActive
                          ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                          : "#ffffff",
                        color: isActive ? "#ffffff" : "#334155",
                        fontWeight: "700",
                        fontSize: "13px",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                          : "none",
                        transition: "all 0.18s ease",
                      }}
                    >
                      {p}
                    </button>
                  );
                })}

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: currentPage === totalPages ? "#cbd5e1" : "#1e5799",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor:
                      currentPage === totalPages ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  Next ›
                </button>
              </div>
            )}

            {totalItems > 0 && (
              <p
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  color: "#94a3b8",
                  marginTop: "12px",
                  marginBottom: 0,
                  fontWeight: "500",
                }}
              >
                Page {currentPage} of {totalPages} • {totalItems} total records
              </p>
            )}
          </div>
        </div>

        {/* Footer */}
        <p
          style={{
            textAlign: "center",
            color: "#94a3b8",
            fontSize: "12.5px",
            marginTop: "24px",
            fontWeight: "500",
          }}
        >
          © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All Rights
          Reserved.
        </p>
      </div>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 CONFIRM MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        centered
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background:
              selectedAction === "success" ? "#059669" : "#dc2626",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            {selectedAction === "success"
              ? "✅ Confirm Approval"
              : "⚠️ Confirm Rejection"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            padding: "24px",
            fontSize: "14px",
            color: "#334155",
            textAlign: "center",
          }}
        >
          <div style={{ fontSize: "40px", marginBottom: "12px" }}>
            {selectedAction === "success" ? "✅" : "⛔"}
          </div>
          <p style={{ margin: 0, fontWeight: "600" }}>
            Are you sure you want to{" "}
            <strong
              style={{
                color: selectedAction === "success" ? "#059669" : "#dc2626",
              }}
            >
              {selectedAction === "success" ? "approve" : "reject"}
            </strong>{" "}
            this bank account?
          </p>
        </Modal.Body>
        <Modal.Footer
          style={{
            borderTop: "1.5px solid #e2e8f0",
            padding: "16px 24px",
            gap: "10px",
            justifyContent: "center",
          }}
        >
          <button
            type="button"
            onClick={() => setShowConfirmModal(false)}
            disabled={actionLoading}
            style={{
              padding: "10px 22px",
              borderRadius: "10px",
              border: "1.5px solid #e2e8f0",
              background: "#ffffff",
              color: "#64748b",
              fontSize: "13px",
              fontWeight: "700",
              cursor: actionLoading ? "not-allowed" : "pointer",
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={confirmStatusChange}
            disabled={actionLoading}
            style={{
              padding: "10px 22px",
              borderRadius: "10px",
              border: "none",
              background: actionLoading
                ? "#cbd5e1"
                : selectedAction === "success"
                ? "linear-gradient(135deg, #059669, #047857)"
                : "linear-gradient(135deg, #dc2626, #b91c1c)",
              color: "#ffffff",
              fontSize: "13px",
              fontWeight: "700",
              cursor: actionLoading ? "not-allowed" : "pointer",
              boxShadow: actionLoading
                ? "none"
                : selectedAction === "success"
                ? "0 4px 12px rgba(5, 150, 105, 0.3)"
                : "0 4px 12px rgba(220, 38, 38, 0.3)",
            }}
          >
            {actionLoading
              ? "Processing..."
              : selectedAction === "success"
              ? "Yes, Approve"
              : "Yes, Reject"}
          </button>
        </Modal.Footer>
      </Modal>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

// ═══════════════════════════════════════════
// 🎨 SHARED STYLES
// ═══════════════════════════════════════════
const labelStyle = {
  display: "block",
  fontSize: "12.5px",
  fontWeight: "700",
  color: "#1e3a5f",
  marginBottom: "6px",
};

const inputStyle = {
  width: "100%",
  padding: "10px 14px",
  borderRadius: "10px",
  border: "1.5px solid #e2e8f0",
  fontSize: "13.5px",
  fontWeight: "500",
  color: "#1e3a5f",
  outline: "none",
  boxSizing: "border-box",
};

const cellBlue = { padding: "12px", fontWeight: "700", color: "#1e5799" };
const cellDark = { padding: "12px", fontWeight: "600", color: "#1e3a5f" };
const cellGray = { padding: "12px", color: "#64748b" };

export default AccountList;